import { useUserCreditManagementData } from './useUserCreditManagementData';
import { CreditManagement } from '../index';

export const UserCreditManagement: React.FC = () => {
  const { credits, isLoading, isError, isFetching, errorMessage } =
    useUserCreditManagementData();

  return (
    <CreditManagement
      credits={credits}
      isLoading={isLoading}
      isError={isError}
      isFetching={isFetching}
      errorMessage={errorMessage}
    />
  );
};
